import {Component} from "react";
import * as  ReactDOM from 'react-dom'

const modalRoot = document.getElementById('modalRoot');

type Props = {
    className: string,
    isOpen: boolean
}

class Modal extends Component<Props> {
    private readonly el: HTMLDivElement;

    constructor(props: Props) {
        super(props);

        this.el = document.createElement('div');
        this.el.classList.add('modal-wrapper');
    }
    
    componentDidMount() {
        if (modalRoot) {
            modalRoot.appendChild(this.el);
        }
    }

    componentWillUnmount() {
        if (modalRoot) {
            modalRoot.removeChild(this.el);
        }
    }

    getWrapper() {
        if (this.props.isOpen) {
            this.el.classList.add('show');
            return this.el;
        }
        
        this.el.classList.remove('show');
        return this.el;
    }
    
    render() {
        const tabIndex = -1;
        return ReactDOM.createPortal(
            this.props.isOpen && 
            <div className={`modal ${this.props.className ? this.props.className : ""}`} tabIndex={tabIndex} aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        {this.props.children}
                    </div>
                </div>
            </div>,
            this.getWrapper()
        );
    }
}

export default Modal;
